export default __webpack_public_path__ + "f00bc0047b5222fd5276f46470e04596.svg";